export default __webpack_public_path__ + "static/media/Bhabani Sankar Rath.b6c4962c.JPG";